import React from 'react'
import PropTypes from 'prop-types'

const getStatusPresentation = (value) => {
    const statuses = {
        EN_OPERACION : "EN OPERACIÓN",
        EN_PROYECTO : "EN PROYECTO",
        FUERA_OPERACION : "FUERA DE OPERACIÓN",
    }
    return statuses[value] || ""
}

const StatusField = ({ source, record = {} }) => <span>{getStatusPresentation(record[source])}</span>

StatusField.propTypes = {
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
}

export default StatusField